import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, requireCore = false, requireCap = null }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-7 w-7 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  const caps = user.capabilities || [];
  const isAdmin = user.is_owner || (user.roles || []).includes("admin");

  if (requireCap && !caps.includes(requireCap)) {
    return <Navigate to="/portal" replace />;
  }
  if (requireCore && !isAdmin) {
    return <Navigate to="/portal" replace />;
  }

  return children;
}
